import { ShieldCheck } from "lucide-react";

export const PayPalTrust = ({ className = "" }) => (
  <div
    className={`flex items-center justify-center gap-2 text-xs text-brand-ink/50 ${className}`}
    data-testid="paypal-trust-badge"
  >
    <ShieldCheck className="w-3.5 h-3.5 text-brand-red" />
    <span>
      Secure checkout by{" "}
      <strong className="font-semibold text-[#003087]">Pay</strong>
      <strong className="font-semibold text-[#009cde]">Pal</strong>
      {" "}— pay with Venmo, PayPal, or any card
    </span>
  </div>
);
